import { render, staticRenderFns } from "./EpicForm.vue?vue&type=template&id=f15b0056&scoped=true&"
import script from "./EpicForm.vue?vue&type=script&lang=js&"
export * from "./EpicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15b0056",
  null
  
)

export default component.exports